import Logo from "@/assets/logos/undiksha.png";
import LogoApp from "@/assets/logos/e-ganesha.png";
import Maskot from "@/assets/logos/maskot.png";

export const web2025 = {
  title: "Penerimaan",
  titleFull: "Sistem Penerimaan Mahasiswa Baru",
  titleAcronym: "SPMB",
  univ: "Universitas Pendidikan Ganesha",
  univAcronym: "Undiksha",
  logo: Logo,
  logoApp: LogoApp,
  maskot: Maskot,
  showAkreditasi: true,
  tagline: "AyoKuliahdiUndiksha",
  contactPhoneUniv: "(0362) 22570",
  contactEmailUniv: "humas@undiksha.ac.id",
  contactPhoneTik: "087730060048",
  contactEmailTik: "upttik@undiksha.ac.id",
  linkX: "https://x.com/undikshabali",
  linkInstagram: "https://www.instagram.com/undiksha.bali/",
  linkFacebook: "https://www.facebook.com/undiksha.bali",
  linkTiktok: "https://www.tiktok.com/@undiksha.bali",
  linkYoutube: "https://www.youtube.com/@UniversitasPendidikanGanesha",
  linkPermohonanInformasi: "https://missu.undiksha.ac.id/ppid/tamu/permohonan",
  linkAduan: "https://missu.undiksha.ac.id/ppid/tamu/pengaduan",
  linkPMB: "https://undiksha.ac.id/pmb",
  linkSNBP: "https://undiksha.ac.id/snbp-2025/",
  linkSNBT: "https://undiksha.ac.id/snbt-2025/",
  linkMandiri: "https://undiksha.ac.id/pmb/",
  linkPascasarjana: "https://undiksha.ac.id/pmb-pasca-2025/",
  linkInformasiBeasiswa: "https://undiksha.ac.id/kemahasiswaan/beasiswa",
  linkInformasiSMBJM: "https://undiksha.ac.id/smbjm-2025/",
  linkOfficialGrupSMBJM: "https://t.me/smbjm2025",
  linkProsedurPembayaranBRI:
    "https://undiksha.ac.id/prosedur-pembayaran-ukt-mahasiswa-baru-undiksha-dengan-layanan-bri-virtual-account-briva/",
  linkProsedurPembayaranBPD:
    "https://undiksha.ac.id/prosedur-pembayaran-dengan-bpd-bali/",
  linkProsedurPembayaranBNI: "https://undiksha.ac.id/",
  // linkPedomanSMBJM:
  //   "https://cdn.undiksha.ac.id/wp-content/uploads/2025/04/02190736/Pedoman-SMBJM-Undiksha-Tahun-2025.pdf",
  linkPedomanSMBJM:
    "https://cdn.undiksha.ac.id/wp-content/uploads/2025/05/29144143/Pedoman-SMBJM-Undiksha-Tahun-2025.pdf",
  linkInstruksiPortofolioOlahraga:
    "https://static1.undiksha.ac.id/penerimaan/Format/INSTRUKSI-KERJA-PORTOFOLIO-OLAHRAGA-SPMB-UNDIKSHA-2025.pdf",
  linkTemplatePortofolioOlahraga:
    "https://static1.undiksha.ac.id/penerimaan/Format/TemplateFormatDokumenOlahraga.rar",
  linkInstruksiPortofolioSeni:
    "https://static1.undiksha.ac.id/penerimaan/Format/INSTRUKSI-KERJA-PORTOFOLIO-SENI.pdf",
  linkTemplatePortofolioSeni:
    "https://static1.undiksha.ac.id/penerimaan/Format/TemplateFormatDokumenSeni.rar",
  linkSuratPernyataanTidakMengembalikanUkt:
    "https://static1.undiksha.ac.id/penerimaan/Format/Format-SURAT-PERNYATAAN-tidak-mengembalikan-UKT.docx",
  address: "Kampus Tengah Undiksha",
  addressStreet: "Jalan Udayana No. 11, Singaraja, Bali",
};

export const web = {
  title: "Penerimaan",
  titleFull: "Sistem Penerimaan Mahasiswa Baru",
  titleAcronym: "SPMB",
  univ: "Universitas Pendidikan Ganesha",
  univAcronym: "Undiksha",
  logo: Logo,
  logoApp: LogoApp,
  maskot: Maskot,
  showAkreditasi: true,
  tagline: "AyoKuliahdiUndiksha",
  contactPhoneUniv: "(0362) 22570",
  contactEmailUniv: "humas@undiksha.ac.id",
  contactPhoneTik: "087730060048",
  contactEmailTik: "upttik@undiksha.ac.id",
  linkX: "https://x.com/undikshabali",
  linkInstagram: "https://www.instagram.com/undiksha.bali/",
  linkFacebook: "https://www.facebook.com/undiksha.bali",
  linkTiktok: "https://www.tiktok.com/@undiksha.bali",
  linkYoutube: "https://www.youtube.com/@UniversitasPendidikanGanesha",
  linkPermohonanInformasi: "https://missu.undiksha.ac.id/ppid/tamu/permohonan",
  linkAduan: "https://missu.undiksha.ac.id/ppid/tamu/pengaduan",
  linkPMB: "https://undiksha.ac.id/pmb",
  linkSNBP: "https://undiksha.ac.id/pmb/tahun2026/snbp",
  linkSNBT: "https://undiksha.ac.id/pmb/tahun2026/snbt",
  linkMandiri: "https://undiksha.ac.id/pmb/tahun2026/smbjm/",
  linkPascasarjana:
    "https://undiksha.ac.id/penerimaan-mahasiswa-baru-pascasarjana-tahun-akademik-2026-2027",
  linkInformasiBeasiswa: "https://undiksha.ac.id/kemahasiswaan/beasiswa",
  linkInformasiSMBJM: "https://undiksha.ac.id/pmb/tahun2026/smbjm/",
  linkOfficialGrupSMBJM: "https://go.undiksha.ac.id/pmb26",
  linkGrupTelegramSMBJM: "https://go.undiksha.ac.id/smbjm2026",
  linkProsedurPembayaranBRI:
    "https://undiksha.ac.id/panduan-pembayaran-tagihan/",
  linkProsedurPembayaranBPD:
    "https://undiksha.ac.id/panduan-pembayaran-tagihan/",
  linkProsedurPembayaranBNI:
    "https://undiksha.ac.id/panduan-pembayaran-tagihan/",
  linkProsedurPembayaran: "https://undiksha.ac.id/panduan-pembayaran-tagihan/",
  // linkPedomanSMBJM:
  //   "https://cdn.undiksha.ac.id/wp-content/uploads/2025/04/02190736/Pedoman-SMBJM-Undiksha-Tahun-2025.pdf",
  linkPedomanSMBJM:
    "https://cdn.undiksha.ac.id/wp-content/uploads/2026/04/02164736/Pedoman-SMBJM-Undiksha-Tahun-2026.pdf",
  linkInstruksiPortofolioOlahraga:
    "https://static1.undiksha.ac.id/penerimaan/Format/INSTRUKSI-KERJA-PORTOFOLIO-OLAHRAGA.pdf",
  linkTemplatePortofolioOlahraga:
    "https://static1.undiksha.ac.id/penerimaan/Format/TemplateFormatDokumenOlahraga.rar",
  linkInstruksiPortofolioSeni:
    "https://static1.undiksha.ac.id/penerimaan/Format/INSTRUKSI-KERJA-PORTOFOLIO-SENI.pdf",
  linkTemplatePortofolioSeni:
    "https://static1.undiksha.ac.id/penerimaan/Format/TemplateFormatDokumenSeni.rar",
  linkSuratPernyataanTidakMengembalikanUkt:
    "https://static1.undiksha.ac.id/penerimaan/Format/Format-SURAT-PERNYATAAN-tidak-mengembalikan-UKT.docx",
  linkKalenderAkademik:
    "https://akademik.undiksha.ac.id/dokumen-akademik/kalender-akademik/",
  linkAkreditasiProgramStudi:
    "https://akademik.undiksha.ac.id/dokumen-akademik/akreditasi-program-studi/",
  address: "Kampus Tengah Undiksha",
  linkFasilitasKampus: "https://undiksha.ac.id/tentang-undiksha/fasilitas/",
  linkBiayaPendidikan: "https://undiksha.ac.id/pmb/tahun2026/biaya-pendidikan/",
  linkPanduanPembayaran: "https://undiksha.ac.id/panduan-pembayaran-tagihan/",
  addressStreet: "Jalan Udayana No. 11, Singaraja, Bali",
};
